import type { RequirementCategory } from '@/types/knowledge_graph'

export const REQUIREMENT_CATEGORY_LABELS: Record<RequirementCategory, string> = {
  functional: '機能要件',
  non_functional: '非機能要件',
  business_rule: '業務ルール',
  constraint: '制約'
}
